<template>
    <div>
        <page-hero
            :heroImage="heroImage"
            :pageTitle="pageTitle"
            :imageAltText="imageAltText"
        ></page-hero>

        <v-container
            class="mt-10"
            style="max-width: 1185px"
        >
            <v-row
                align="center"
                justify="space-around"
            >
                <v-col
                    col="12"
                    md="6"
                    align="center"
                >
                    <page-subheading title="Who We Are"></page-subheading>
                    <history-card></history-card>
                </v-col>

                <v-col
                    col="12"
                    md="4"
                    align="center"
                    justify="center"
                >
                    <v-img
                        class="my-14"
                        max-width="400px"
                        src="@/assets/mark_logo.png"
                        alt="Prospira's 'S' type logo"
                    ></v-img>
                </v-col>
            </v-row>
        </v-container>


        <v-container>
            <page-subheading title="Our History"></page-subheading>
            <prospira-timeline></prospira-timeline>
        </v-container>
    </div>
</template>

<script>
import HistoryCard from '@/components/about-us/HistoryCard.vue'
import PageHero from '@/components/PageHero.vue'
import PageSubheading from '@/components/PageSubheading.vue'
import ProspiraTimeline from '@/components/about-us/ProspiraTimeline.vue'

export default {
    components: {
        'history-card': HistoryCard,
        'page-hero': PageHero,
        'page-subheading': PageSubheading,
        'prospira-timeline': ProspiraTimeline
    },
    name: 'AboutUsView',
    data: () => {
        return {
            heroImage: require('@/assets/about-us/about_us_hero1800x1013.jpg'),
            pageTitle: "About Us",
            imageAltText: "Findlay Office main entrance"
        }
    }
}
</script>
